const materialCategories = {
  drugs: 'Лекарства',
  inventory: 'Инвентарь',
  documents: 'Документы',
  other: 'Другое',
};

export default materialCategories;